import DOMPurify from "dompurify";
import { marked } from "marked";

/**
 * Convert Markdown content to sanitized HTML for TipTap editor.
 * DOMPurify strips dangerous attributes (onerror, onclick, javascript: URLs, etc.)
 * before the HTML is handed to TipTap's setContent().
 * We allow `style` on <img> tags so that resized images (width: Xpx) are preserved.
 */
export function markdownToHtml(markdown: string): string {
  if (!markdown) return "";
  const rawHtml = marked.parse(markdown, { breaks: true }) as string;
  return DOMPurify.sanitize(rawHtml, {
    ADD_ATTR: ["style"],
    ALLOWED_ATTR: ["src", "alt", "title", "href", "class", "style", "target", "rel", "width", "height"],
  });
}
